import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import DropdownRow from '@/forms/FormElements/Rows/DropdownRow/DropdownRow.vue';
import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import MessageRow from '@/forms/FormElements/Rows/MessageRow/MessageRow.vue';
import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import NameRow from '@/forms/FormElements/Rows/NameRow/NameRow.vue';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';
import DebugModel from '@/forms/FormElements/Common/DebugModel/DebugModel.vue';
import FormWrapper from '@/forms/FormElements/Common/FormWrapper/FormWrapper.vue';

import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import {
  GET_ITINERARIES_REQUEST,
  GET_DATES_REQUEST,
  DerSignUpModuleState,
} from '../DerSignUpModule.store';
import SelectItem from '@/common/interfaces/SelectItem';
import { SecondStepModel, names, getDropdownProps } from './SecondStep.types';

import getValidation from './SecondStep.validations';
import Message from '@/forms/Validations/Message';
import ThankYouMessage from '@/modules/DerSignUpModule/ThankYouMessage/ThankYouMessage.vue';
import CheckBoxRow from '@/forms/FormElements/Rows/CheckBoxRow/CheckBoxRow.vue';
import ArrowSmall from '@/assets/icons/arrow-small.svg?inline';
import '@/components/Accordion/Accordion.scss';
import { Getter } from 'vuex-class';
import { Country, PageMeta, PAGE_META } from '@/store/modules/metadataModule';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  components: {
    MessageRow,
    TextRow,
    NameRow,
    ButtonRow,
    DebugModel,
    FormWrapper,
    DropdownRow,
    EmailRow,
    ThankYouMessage,
    ArrowSmall,
    CheckBoxRow,
  },
})
export default class SecondStep extends mixins(FormValidationMixin, StoreModuleMixin) {
  state!: DerSignUpModuleState;
  maxReceipts: number = 12;
  isFamily: boolean = false;

  @Prop({ type: Array as () => SelectItem[], default: () => [] })
  readonly destinations!: SelectItem[];

  @Prop() readonly bottomText!: string;

  getItinerariesRequest: (payload: getDropdownProps) => void = this.getAction(GET_ITINERARIES_REQUEST);
  getDatesRequest: (payload: getDropdownProps) => void = this.getAction(GET_DATES_REQUEST);

  @Getter(PAGE_META)
  PageMeta!: PageMeta;

  isNewsletterChecked: boolean = false;

  get itineraries() {
    return this.state.Itinararies;
  }

  get dates() {
    return this.state.Dates;
  }

  toggleIsfamily() {
    this.isFamily = !this.isFamily;
    if (!this.model.Recipients.length) {
      this.addRecipient()
    } else {
      this.model.Recipients.splice(0, this.model.Recipients.length);
    }
  }

  addRecipient() {
    const id = this.model.Recipients.length + 1;
    this.model.Recipients.push({
      Id: id,
      Name: 'TBD',
      Email: '',
    });
  }

  removeLastRecipient() {
    this.model.Recipients.pop();
  }

  resetItinAndDateFields() {
    this.model.ItineraryId = '';
    this.model.DepartureId = '';
  }

  getItineraries(destinationId: number) {
    this.getItinerariesRequest({destinationId});
    this.resetItinAndDateFields();
  }

  getDates(itineraryId: number) {
    this.getDatesRequest({itineraryId});
    this.model.DepartureId = '';
  }

  created() {
    if (this.PageMeta.Country === Country.US) this.isNewsletterChecked = true;
  }

  mounted() {
    this.model.Recipients.pop();
    if (this.destinationId) this.getItinerariesRequest({destinationId: this.destinationId, showloading: false})
    if (this.itineraryId) this.getDatesRequest({itineraryId: this.itineraryId, showloading: false})
  }

  get itineraryId() {
    return this.state?.PrePopulateItineraryId
  }

  get destinationId() {
    return this.state?.PrePopulateDestinationId
  }

  get DepartureNumber() {
    return this.state?.PrePopulateDepartureNumber
  }

  get date() {
    if (this.DepartureNumber) {
      const date = this.dates.find(d => String(d.Value).includes(String(this.DepartureNumber)))
      if (date) return date.Value;
    }
  }

  names = names;
  model: SecondStepModel = model;
  messages: Message[] = messages;
}
